module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_Bankoslowka_APLIKACJA_BANKOWA.5092038e.mp3";